import { GlobalConfigKeys, useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { logger } from '@/utils/logging';

export type TrustlyConfigurations = {
    accessId: string;
    merchantId: string;
};

const TAG = '[Trustly]';

/**
 * Trustly credentials come from the `TrustlySettings` key-value pairs slice on the ACS Global Configurations
 * document (apps_global_configurations / _rc / _dev), so each environment resolves its own values.
 */
export const useTrustlyConfigurations = (): TrustlyConfigurations => {
    const trustlySettings = useJurisdictionStore(
        state => state.jurisdictionSettings?.globalSettings?.keyValuePairs?.[GlobalConfigKeys.TrustlySettings]
    );

    const accessId = trustlySettings?.ACCESS_ID ?? '';
    const merchantId = trustlySettings?.MERCHANT_ID ?? '';

    if (!accessId || !merchantId) {
        logger.warn(TAG, 'Missing TrustlySettings (ACCESS_ID / MERCHANT_ID) in Prismic global configurations');
    }

    return { accessId, merchantId };
};
